export interface CompItem {
  key: string;
  label: string;
  color: string;
  widthPct: number;
  pctText: string;
}

/** コスト構成バー（原価/手数料/送料/ポイント/広告費/利益の積み上げ）＋凡例。 */
export function CompBar({
  items,
  height = 8,
  showLegend = true,
}: {
  items: CompItem[];
  height?: number;
  showLegend?: boolean;
}) {
  return (
    <div className="pl-comp">
      <div className="pl-comp-bar" style={{ height }}>
        {items.map((c) => (
          <div key={c.key} style={{ width: `${Math.max(0, c.widthPct)}%`, background: c.color }} />
        ))}
      </div>
      {showLegend && (
        <div className="pl-comp-legend">
          {items.map((c) => (
            <span key={c.key} className="pl-comp-legend-item">
              <span className="pl-comp-dot" style={{ background: c.color }} />
              {c.label} {c.pctText}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
